module.exports = __webpack_public_path__ + "img/vertical_4_4_9006.564795ef.png";